<template>
  <div>
    <div class="vx-row" id="formulation_qa_table">
      <div class="vx-col w-full">
        <vx-card title="QC Test Guide" class="mb-3">

          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickSave)">

              <div class="flex flex-wrap items-center justify-end mt-2">
                <vs-button button="submit" v-if="$canAll(formulationQcTestGuidePermissions)"
                           class="ml-auto mt-2" color="primary" size="small" type="filled">Save Changes
                </vs-button>
              </div>

              <div class="vx-row mb-3">
                <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <ValidationProvider vid="odour" name="odour" rules="required" v-slot="{ errors }">
                    <small class="label">Odour</small>
                    <vs-input type="text" v-model="form.odour" name="odour" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <ValidationProvider vid="flash_point" name="flash_point" rules="required" v-slot="{ errors }">
                    <small class="label">Flash Point</small>
                    <vs-input type="text" v-model="form.flash_point" name="flash_point" class="w-full"
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather" :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <ValidationProvider vid="taste" name="taste" rules="required" v-slot="{ errors }">
                    <small class="label">Taste</small>
                    <vs-input type="text" v-model="form.taste" name="taste" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              :disabled="!$canAll(formulationQcTestGuidePermissions)" />
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-3">
                <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <ValidationProvider vid="appearance" name="appearance" rules="required" v-slot="{ errors }">
                    <small class="label">Appearance From</small>
                    <vs-input type="text" v-model="form.appearance_from" name="appearance" class="w-full"
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather" :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <ValidationProvider vid="appearance" name="appearance" rules="required" v-slot="{ errors }">
                    <small class="label">Appearance To</small>
                    <vs-input type="text" v-model="form.appearance_to" name="appearance" class="w-full"
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather" :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/3 w-full md:mb-0" v-if="formulation.formulation_type !== 'liquid'">
                  <ValidationProvider vid="moisture" name="moisture" rules="required" v-slot="{ errors }">
                    <small class="label">Moisture</small>
                    <vs-input type="text" v-model="form.moisture" name="moisture" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </ValidationProvider>
                </div>
                <!-- <div class="vx-col md:w-1/3 w-full md:mb-0">
                  <ValidationProvider vid="dosage" name="dosage" rules="required" v-slot="{ errors }">
                    <small class="label">Max Dosage</small>
                    <vs-input type="text" v-model="form.dosage" name="dosage" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </ValidationProvider>
                </div> -->
                <div class="vx-col md:w-1/3 w-full md:mb-0" :class="formulation.formulation_type !== 'liquid' ? 'mt-2' : ''">
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <small class="label">Brix</small>
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text bg-primary">
                          <span>from</span>
                        </div>
                      </template>
                      <vs-input class="w-full" name="brix_from" type="text"
                                v-model="form.brix_from" :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                    </vx-input-group>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <small class="label">&nbsp;</small>
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text bg-primary">
                          <span>to</span>
                        </div>
                      </template>
                      <vs-input class="w-full" name="brix_to" type="text"
                                v-model="form.brix_to" :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                    </vx-input-group>
                  </div>
                  </div>
                </div>
              </div>
              <div class="vx-row mb-4" v-if="formulation.formulation_type === 'liquid'">
                <div class="vx-col md:w-1/6 w-full md:mb-0">
                  <small class="label">SG</small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>from</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="sg_from" type="text"
                              v-model="form.sg_from" :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/6 w-full md:mb-0">
                  <small class="label">&nbsp;</small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>to</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="sg_to" type="text"
                              v-model="form.sg_to" :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/6 w-full md:mb-0">
                  <small class="label">RI</small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>from</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="ri_from" type="text"
                              v-model="form.ri_from" :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/6 w-full md:mb-0">
                  <small class="label">&nbsp;</small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>to</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="ri_to" type="text"
                              v-model="form.ri_to" :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/6 w-full md:mb-0">
                  <small class="label">pH</small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>from</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="ph_from" type="text"
                              v-model="form.ph_from" :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-1/6 w-full md:mb-0">
                  <small class="label">&nbsp;</small>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>to</span>
                      </div>
                    </template>
                    <vs-input class="w-full" name="ph_to" type="text"
                              v-model="form.ph_to" :disabled="!$canAll(formulationQcTestGuidePermissions)"/>
                  </vx-input-group>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </vx-card>
        <formulation-qc-test-tab
          ref="formulationQcTestTab"
          v-bind:formulation_data="formulation_data"
          :formulationPermissions="formulationPermissions"
          v-on:refreshGeneral="refreshParentData"
          />
        <formulation-qa-tab
          v-bind:formulation_data="formulation"
          v-on:refreshGeneral="refreshParentData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import FormulationQcTestTab from './FormulationQcTestTab.vue'
import FormulationQaTab from "@/views/pages/formulations/FormulationQaTab";

const FormulationsRepository = RepositoryFactory.get('formulations')

export default {
  name: "FormulationQcTestGuideTab",
  data() {
    return {
      formulationId: '',
      form: {},
    }
  },
  components:{
    FormulationQaTab,
    FormulationQcTestTab
  },
  props: {
    formulation_data: {
      type: Object,
      default: {},
    },
    formulationPermissions: {
      type: Array,
      default: [],
    }
  },
  methods: {
    async onClickSave() {
      try {
        const payload = {}
        Object.assign(payload, this.form)
        await FormulationsRepository.updateQcTestGuide(this.formulationId, payload)
        await this.$emit('refreshGeneral')
        this.showSuccessMessage('QC test guide saved successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    startQcTest() {
      this.$refs.formulationQcTestTab.onClickCreateQcTest()
    },
    async refreshParentData(){
      await this.$emit('refreshGeneral')
    },
  },
  async mounted() {
    this.formulationId = this.$route.params.id
    if (this.formulation.q_c_quide) {
      this.form = this.formulation.q_c_quide
    }
  },
  computed: {
    formulation: function () {
      return this.formulation_data
    },
    formulationQcTestGuidePermissions: function () {
      return this.formulationPermissions.concat([ 'edit-formulation-guide' ])
    }
  },
  mixins: [SuccessMessage, ErrorMessages]
}
</script>

<style scoped>

.__table-heading-small {
  /*font-size: x-small;*/
  /*font-weight: normal;*/
}

</style>
